import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const OutlookIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#000" d="M12.24 4.82v3.52l1.23.77q.06.01.14 0l5.3-3.57c0-.42-.4-.72-.63-.72z" />
    <path
      fill="#000"
      d="m12.24 9.65 1.12.77c.16.12.35 0 .35 0l5.2-3.46v6.48c0 .7-.46 1-.97 1h-5.7zM6.43 8.03q-.59 0-.92.54t-.34 1.42q0 .9.34 1.43t.89.52q.56 0 .9-.51.32-.51.33-1.41 0-.95-.33-1.47-.32-.52-.87-.52"
    />
    <path
      fill="#000"
      d="M1.1 3.03V16.8L11.58 19V1zm7.01 9.21q-.66.88-1.73.88-1.04 0-1.7-.85a3.5 3.5 0 0 1-.65-2.2q0-1.44.66-2.33a2.1 2.1 0 0 1 1.77-.89 2 2 0 0 1 1.67.85q.64.85.64 2.24a3.7 3.7 0 0 1-.66 2.3"
    />
  </svg>
);
